import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { embedDashboard } from '@superset-ui/embedded-sdk';

const SupersetDashboardEmbed = ({
  instanceUrl,
  dashboardUuid,
  fetchGuestToken,
  hideTitle,
  style
}) => {
  const mountRef = useRef(null);

  useEffect(() => {
    if (!mountRef.current || !instanceUrl || !dashboardUuid || !fetchGuestToken) {
      return undefined;
    }

    let cancelled = false;
    const mountPoint = mountRef.current;

    const mountDashboard = async () => {
      if (cancelled) return;

      await embedDashboard({
        id: dashboardUuid,
        supersetDomain: String(instanceUrl).replace(/\/$/, ''),
        mountPoint,
        fetchGuestToken,
        dashboardUiConfig: {
          hideTitle: hideTitle !== false
        }
      });

      if (cancelled || !mountPoint) return;

      const iframe = mountPoint.querySelector('iframe');
      if (iframe) {
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = 'none';
        iframe.style.display = 'block';
      }
    };

    mountDashboard().catch(() => {
      // intencional: a tela consumidora exibe erro/placeholder
    });

    return () => {
      cancelled = true;
      if (mountPoint) {
        mountPoint.innerHTML = '';
      }
    };
  }, [instanceUrl, dashboardUuid, fetchGuestToken, hideTitle]);

  if (!instanceUrl || !dashboardUuid || !fetchGuestToken) return null;

  return (
    <div
      ref={mountRef}
      style={{
        width: '100%',
        height: '100%',
        minHeight: 'calc(100vh - 180px)',
        overflow: 'hidden',
        ...style
      }}
    />
  );
};

SupersetDashboardEmbed.propTypes = {
  instanceUrl: PropTypes.string,
  dashboardUuid: PropTypes.string,
  fetchGuestToken: PropTypes.func,
  hideTitle: PropTypes.bool,
  style: PropTypes.object
};

SupersetDashboardEmbed.defaultProps = {
  instanceUrl: '',
  dashboardUuid: '',
  fetchGuestToken: undefined,
  hideTitle: true,
  style: undefined
};

export default SupersetDashboardEmbed;
